import {createSelectionSlice} from 'entities/monitor';

const domainMonitor = createSelectionSlice('domainMonitor', ({domainMonitorReducer}) => domainMonitorReducer);

export default domainMonitor.reducer;
export const {toggleOne, selectAllOnPage, clearAll} = domainMonitor.actions;

export const domainMonitorSelectedIdsSelector = domainMonitor.selectedIdsSelector;
export const isSelectedAllSelector = domainMonitor.isSelectedAllSelector;
